var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var PosAngleData = require("../abstract/posAngleData.js");
var EllipseData = require("../svg/ellipseData.js");

var HoleData = function (pos, angle, shape) {
    var self = this;

    this.makeObservableTreeNode();

    this.addPosAngle(pos, angle);

    this.shape = this.value("shape", true);

    this.geometry = this.cachedFunction("geometry",
        this._getGeometry,
        [[this.shape, this.shape.onBubble], this.pos, this.angle]
    );

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        this._getSegmentedGeometry,
        [[this.shape, this.shape.onBubble], this.pos, this.angle]
    );

    this.bufferedSegmentedGeometry = this.cachedFunction("bufferedSegmentedGeometry",
        function (precision, layerIndex, layerType, bufferSize) {
            return this.segmentedGeometry(precision, layerIndex, layerType).buffer(bufferSize);
        },
        [this.segmentedGeometry]
    );

    this.outlineGeometry = this.segmentedGeometry;

    this.boundingBox = this.cachedFunction("boundingBox",
        function () {
            return self.geometry().getBB(); },
        [this.geometry]
    );

    if (shape != undefined) this.shape(shape);
};
lib_core.mixin(HoleData, lib_core.ObservableTreeNode, PosAngleData);
lib_core.JsonParser.registerClass(HoleData, "HoleData");

module.exports = HoleData;

HoleData.prototype._getGeometry = function () {
    var poly = this.shape().geometry();
    poly = poly.translate(this.pos());
    poly = poly.rotate(this.angle(), this.pos());
    return poly;
};

HoleData.prototype._getSegmentedGeometry = function (precision) {
    var poly = this.shape().segmentedGeometry(precision);
    poly = poly.translate(this.pos());
    poly = poly.rotate(this.angle(), this.pos());

    return poly;
};

// TODO
HoleData.prototype.getLayers = function () {
    var layers = new lib_core.Collections.HashSet();
    if(this.parent().number_of_layers) {
        for(var i=0; i<this.parent().number_of_layers(); i++) {
            layers.add(i);
        }
    }
    return layers;
};

